import { render, staticRenderFns } from "./WhatsAppMessageTemplateCallToAction.vue?vue&type=template&id=83a469b2&scoped=true&"
import script from "./WhatsAppMessageTemplateCallToAction.vue?vue&type=script&lang=js&"
export * from "./WhatsAppMessageTemplateCallToAction.vue?vue&type=script&lang=js&"
import style0 from "./WhatsAppMessageTemplateCallToAction.vue?vue&type=style&index=0&id=83a469b2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a469b2",
  null
  
)

export default component.exports